export const abbreviateNumber = (number: number, maxPlaces: number, forcePlaces: number | boolean, forceLetter: string | boolean) => {
    if (forceLetter !== false) return annotateNumber(number, maxPlaces, forcePlaces, forceLetter);
    let abbr;

    if (number >= 1e12) {
        abbr = 'T';
    } else if (number >= 1e9) {
        abbr = 'B';
    } else if (number >= 1e6) {
        abbr = 'M';
    } else if (number >= 1e3) {
        abbr = 'K';
    } else {
        abbr = '';
    }

    return annotateNumber(number, maxPlaces, forcePlaces, abbr);
};

export const annotateNumber = (number: number, maxPlaces: number, forcePlaces: number | boolean, abbr: string | boolean) => {
    // set places to false to not round
    let rounded = 0;

    // oxlint-disable-next-line typescript/switch-exhaustiveness-check
    switch (abbr) {
        case 'T':
            rounded = number / 1e12;
            break;
        case 'B':
            rounded = number / 1e9;
            break;
        case 'M':
            rounded = number / 1e6;
            break;
        case 'K':
            rounded = number / 1e3;
            break;
        case '':
            rounded = number;
            break;
    }

    let roundedString = '';
    if (maxPlaces) roundedString = rounded.toFixed(maxPlaces).toString();

    if (typeof forcePlaces === 'number') roundedString = Number(rounded).toFixed(forcePlaces);
    const abbrOutput = typeof roundedString === 'string' ? abbr.toString() : '';
    return roundedString + abbrOutput;
};
